import React from 'react'
import { Route, IndexRoute } from 'react-router'
import App from '../components/App'
import NotFoundContainer from '../components/common/NotFoundContainer'
import ExternalRedirect from '../components/common/ExternalRedirect'

//
// ─── MANAGER SPECIFIC PAGES ─────────────────────────────────────────────────────
//

import {
  managerAppRoutes,
  managerSchoolRoutes,
  managerTeacherRoutes,
  managerStudentsRoutes,
  managerSupervisorRoutes
} from './managerRoutes'

//
// ─── ACCOUNT PAGES ──────────────────────────────────────────────────────────────
//

import Login from '../components/authentication/Login'
import { accountRoutes } from './accountRoutes'

//
// ─── SCHOOL ROUTES ──────────────────────────────────────────────────────────────
//

import { SchoolStudentManagementRoute } from './schoolRoutes'

//
// ─── AUTHENTICATION ROUTES ──────────────────────────────────────────────────────
//

import DashboardContainer from '../components/dashboard/DashboardContainer'
import { loginRoute, signupRoute, activateRoute } from './authRoutes'

//
// ─── AUTHENTICATION HIGHER ORDER COMPONENTS ─────────────────────────────────────
//

import RequireAuthentication from '../components/HOCs/RequireAuth'
import RedirectIfAuthenticated from '../components/HOCs/RedirectIfAuthenticated'

//
// ─── PROFILE CONTAINERS ─────────────────────────────────────────────────────────
//

import { appRoutes } from './appRoutes'
import { eventsRoutes } from './eventsRoutes'
import { ordersRoutes } from './ordersRoutes'
import { productsRoutes } from './productsRoutes'
import { messagesRoutes } from './messagesRoutes'
import { ticketingRoutes } from './ticketingRoutes'
import { onlineTestRoutes } from './onlineTestRoutes'
import { supervisorRoutes } from './supervisorRoutes'
import { creditRoutes } from './creditAndPaymentRoutes'
import { certificatesRoutes } from './certificatesRoutes'
import VerifyEmailPage from '../components/authentication/VerifyEmailPage'
import { ShowProfileContainerRoute, ProfileEditContainerRoute } from './profileRoutes'
import DashboardSummeryContainer from '../components/dashboard/DashboardSummeryContainer'

//
// ─── SERVICES ───────────────────────────────────────────────────────────────────
//

import { ServiceDetailsPageRoute } from './servicesRoutes'

// ────────────────────────────────────────────────────────────────────────────────

export default (
  <Route path="/" component={App}>
    {/* auth routes */}
    <IndexRoute component={RedirectIfAuthenticated(Login)} />
    {loginRoute}
    {activateRoute}
    {signupRoute}
    <Route path="account/verify/:token" component={VerifyEmailPage} />

    <Route path="ext-redirect/*" component={ExternalRedirect} />

    {/* dashboard routes */}
    <Route path="dashboard" component={RequireAuthentication(DashboardContainer)}>
      <IndexRoute component={DashboardSummeryContainer} />
      {ProfileEditContainerRoute}
      {ShowProfileContainerRoute}
      {SchoolStudentManagementRoute}
      {managerAppRoutes}
      {managerTeacherRoutes}
      {managerStudentsRoutes}
      {managerSchoolRoutes}
      {managerSupervisorRoutes}
      {accountRoutes}
      {messagesRoutes}
      {ticketingRoutes}
      {eventsRoutes}
      {productsRoutes}
      {ordersRoutes}
      {creditRoutes}
      {onlineTestRoutes}
      {supervisorRoutes}
      {certificatesRoutes}
      {appRoutes}
      {ServiceDetailsPageRoute}
    </Route>

    {/* not found routes */}
    <Route path="*" component={NotFoundContainer} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/index.js